module.exports = "<div seedelement><span tabindex=\"0\"></span>\n  <lui-textfield></lui-textfield>\n  <slot></slot>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-menu/theme/lui-menu.html
// module id = 244
// module chunks = 0 1 3